import { defineWorkflow } from './workflow-builder'

/**
 * WF-KSL-01 (Consolidation Task / Konsolidasi Pallet FG) — nomor workflow 12.
 * ERD v010 `consolidation_task` (`ksl_no`, `sku_id`, `from_pallet_id`, `to_pallet_id`, `target_fill`, `fill_reason`,
 * `task_status`) ditambah [ERD-GAP] `status_id`, `submission_id`, `operator_id`, `jenis`, `package_no`, `freed_count`,
 * `stop_reason` (laporan 14). Alur mengikuti 03A: Ditugaskan → Dimuat → Selesai / Dihentikan.
 * Prototype: Admin dan Kadiv WH FG menerbitkan / menghentikan tugas; Operator WH FG memuat & menempatkan.
 */
export const WF_KSL = defineWorkflow({
  no: 12,
  code: 'WF-KSL-01',
  name: 'Pallet Consolidation Workflow',
  entity: 'consolidation_task',
  statuses: [
    ['KSL_ASSIGNED', 'Ditugaskan', true, false, '#3B82F6', 'Tugas konsolidasi terbit untuk operator'],
    ['KSL_LOADED', 'Dimuat', false, false, '#F59E0B', 'Unit sudah dimuat, dibawa ke pallet tujuan'],
    ['KSL_DONE', 'Selesai', false, true, '#10B981', 'Seluruh unit pindah ke pallet tujuan'],
    ['KSL_STOPPED', 'Dihentikan', false, true, '#6B7280', 'Tugas dihentikan sebelum selesai']
  ],
  actors: [
    ['ACT_KSL_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_KSL_KADIV_FG', 'Kadiv WH FG', 'kadiv_wh_fg', null],
    ['ACT_KSL_OP_FG', 'Operator WH FG', 'operator_wh_fg', null]
  ],
  components: [
    ['CMP_KSL_CARRY', 'Tombol Bawa ke Pallet Tujuan', 'ACTION', {}],
    ['CMP_KSL_COMPLETE', 'Tombol Selesai Konsolidasi', 'ACTION', {}],
    ['CMP_KSL_STOP', 'Tombol Hentikan Tugas', 'ACTION', {}],
    ['CMP_KSL_PANEL_HEADER', 'Panel Header Tugas', 'PANEL', {}]
  ],
  actions: [
    ['ACT_KSL_CARRY', 'KSL_ASSIGNED', 'KSL_LOADED', 'CMP_KSL_CARRY', false, false, null],
    ['ACT_KSL_COMPLETE', 'KSL_LOADED', 'KSL_DONE', 'CMP_KSL_COMPLETE', false, false, null],
    ['ACT_KSL_STOP_ASSIGNED', 'KSL_ASSIGNED', 'KSL_STOPPED', 'CMP_KSL_STOP', true, true, null],
    ['ACT_KSL_STOP_LOADED', 'KSL_LOADED', 'KSL_STOPPED', 'CMP_KSL_STOP', true, true, null]
  ],
  eligibility: [
    ['ACT_KSL_CARRY', 'ACT_KSL_OP_FG'],
    ['ACT_KSL_COMPLETE', 'ACT_KSL_OP_FG'],
    ['ACT_KSL_STOP_ASSIGNED', 'ACT_KSL_ADMIN_FG'],
    ['ACT_KSL_STOP_ASSIGNED', 'ACT_KSL_KADIV_FG'],
    ['ACT_KSL_STOP_LOADED', 'ACT_KSL_ADMIN_FG'],
    ['ACT_KSL_STOP_LOADED', 'ACT_KSL_KADIV_FG']
  ],
  panels: [
    ['CMP_KSL_PANEL_HEADER', 'KSL_ASSIGNED', 'read', null],
    ['CMP_KSL_PANEL_HEADER', 'KSL_LOADED', 'read', null]
  ],
  emailStatuses: []
})

export type KslStatusCode = (typeof WF_KSL.spec.statuses)[number][0]
export type KslActionName = (typeof WF_KSL.spec.actions)[number][0]
export const buildWorkflowKslSeed = WF_KSL.build
